import { Card, CardContent, CardHeader } from "../ui/card";
const MissionIssue = () => {
  return (
    <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
      <div className="flex flex-col md:flex-row">
        <div>
          <br />
          Les fuites sur les réseaux de distribution causent d’importants
          gaspillages et peuvent générer des factures décuplées. La SEOP utilise
          deux méthodes afin de les localiser sur les 1 100 km de réseau
          d’AQUAVESC, dont elle assure la surveillance :
          <ul className="ml-10 list-disc">
            <li>
              La sectorisation des réseaux : La SEOP a délimité différents
              secteurs. Cette segmentation lui permet d’identifier avec
              précision les volumes d’eau introduits. Des mesures sont
              effectuées à la nuit tombée, quand la consommation est quasi nulle
              : une fuite est alors suspectée en cas de débit anormalement
              élevé.
            </li>
            <li>
              La prélocalisation des fuites : des capteurs implantés sur
              l’ensemble des réseaux permettent d’enregistrer les bruits émis
              par les fuites, facilitant ainsi leur localisation.Par ailleurs,
              le réseau de distribution fait l’objet de travaux réguliers
              d’entretien et de renouvellement.
            </li>
          </ul>
        </div>
        <div className="flex md:justify-center ">
          {" "}
          <Card className="p-5 md:w-80 bg-[#3CC6F7] border-primary w-full  mt-5 md:mt-0">
            <CardHeader>
              <h1 className="text-xl font-semibold text-white">
                Le saviez-vous ?
              </h1>
            </CardHeader>
            <CardContent></CardContent>
            <h3 className="text-white ">
              Pour repérer vous-même les fuites d’eau chez vous, relevez les
              chiffres sur votre compteur la nuit avant de vous coucher et ne
              consommez pas d’eau. S’ils ont augmenté le lendemain matin, c’est
              qu’il y a une fuite.
            </h3>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default MissionIssue;
